<template>
    <div>
        <div class="appHeader" style="z-index: 9999;">
            <div class="left">
                <a v-if="indexPage == true" onclick="window.history.go(-1); return false;" class="headerButton">
                    <ion-icon name="chevron-back-outline"></ion-icon>
                    {{ title ?? 'بازگشت' }}
                </a>
                <a v-else :href="to" class="headerButton">
                    <ion-icon name="chevron-back-outline"></ion-icon>
                    بازگشت
                </a>
            </div>
            <div class="pageTitle">
                <!-- <img width="35" src="assets/img/sabze1.png" alt=""> -->
                ایران ترابر رانندگان
                <!-- <img width="35" src="assets/img/sabze1.png" alt=""> -->
            </div>
            <div class="right">

                <a href="#" class="headerButton" data-bs-toggle="offcanvas" data-bs-target="#actionSheetShare"
                    @click="backTell()">
                    <ion-icon name="chatbubbles-outline"></ion-icon>
                </a>
                <!-- <a v-on:click="getLocation()" class="headerButton">
        <ion-icon name="location-outline"></ion-icon>
      </a> -->
                <!-- Modal Form -->

                <!-- * Modal Form -->
            </div>
        </div>
    </div>

</template>
<script>
export default {
    props: ['to', 'indexPage', 'title'],
    methods: {
        backTell() {
            if (history.pushState) {
                var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?backTell=1';
                window.history.pushState({ path: newurl }, '', newurl);
            }
        }
    }
}
</script>
<style></style>